import { Loader } from '@zeeve-platform/loader-component';
import BaseUrls from '../../utils/baseUrls';
import { prefixPath } from '../../utils/helpers';

interface props{
    showLoader: boolean
}
const CustomLoader = ({ showLoader }:props) => {
  const imgSubPath = window.location.origin;
  const theme = BaseUrls.getkey();

  const spinner = imgSubPath + prefixPath(`/img/${theme}/spin.svg`);
  return (
        <div>
            {showLoader && <Loader imagePath={spinner} />}
        </div>
  );
};
export default CustomLoader;